import 'ie11';
import 'config';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'i18n';
import Router from 'Router';

import IdleTimerContainer from 'components/IdleTimer/IdleTimerContainer';
import SessionTimeout from 'components/sessionTimeout/SessionTimeout';
import ErrorBoundary from 'pages/ErrorBoundary/ErrorBoundary';
import Providers from 'providers';

import '@fairstone/style/themes/fairstone/main.scss';
import 'antd/dist/antd.css';
import 'style/main.css';

ReactDOM.render(
    <BrowserRouter>
        <Providers>
            <ErrorBoundary>
                <Router />
                <IdleTimerContainer />
                <SessionTimeout />
            </ErrorBoundary>
        </Providers>
    </BrowserRouter>,
    document.getElementById('root')
);
